/*
 * Copyright © 2023 Broadcom. All rights reserved. The term “Broadcom” refers to Broadcom Inc. and/or its subsidiaries. All trademarks, trade names, service marks, and logos referenced herein belong to their respective companies.
 * This software and all information contained therein is confidential and proprietary and shall not be duplicated, used, disclosed or disseminated in any way except as authorized by the applicable license agreement, without the express written permission of Broadcom. All authorized reproductions must be marked with this language.
 * EXCEPT AS SET FORTH IN THE APPLICABLE LICENSE AGREEMENT, TO THE EXTENT PERMITTED BY APPLICABLE LAW OR AS AGREED BY BROADCOM IN ITS APPLICABLE LICENSE AGREEMENT, BROADCOM PROVIDES THIS DOCUMENTATION “AS IS” WITHOUT WARRANTY OF ANY KIND, INCLUDING WITHOUT LIMITATION, ANY IMPLIED WARRANTIES OF MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE, OR NONINFRINGEMENT. IN NO EVENT WILL BROADCOM BE LIABLE TO THE END USER OR ANY THIRD PARTY FOR ANY LOSS OR DAMAGE, DIRECT OR INDIRECT, FROM THE USE OF THIS DOCUMENTATION, INCLUDING WITHOUT LIMITATION, LOST PROFITS, LOST INVESTMENT, BUSINESS INTERRUPTION, GOODWILL, OR LOST DATA, EVEN IF BROADCOM IS EXPRESSLY ADVISED IN ADVANCE OF THE POSSIBILITY OF SUCH LOSS OR DAMAGE.
 */
import {
  FETCH_API_COMPONENT_INFO,
  FETCH_API_COMPONENT_INFO_SUCCESS,
  FETCH_API_COMPONENT_INFO_FAILURE,
  SET_SHOWING_COMPONENT_INFO
} from './actionTypes'
import { Info } from './info';

export function setShowingComponentInfo(showingComponentInfo) {
  return (dispatch, getState) => {
    dispatch(
        {
          type:SET_SHOWING_COMPONENT_INFO,
          isShowingComponentInfo:showingComponentInfo,
        }
    );
  }
}

export function fetchApiComponentInfo() {
  return {
    type: FETCH_API_COMPONENT_INFO
  }
}
export function fetchApiComponentInfoSuccess(json) {
  return {
    type: FETCH_API_COMPONENT_INFO_SUCCESS,
    info: json
  }
}
export function fetchApiComponentInfoFailure(error) {
  return {
    type: FETCH_API_COMPONENT_INFO_FAILURE,
    errorMessage: error.message,
    error: error.response,
  }
}
export function getApiComponentInfo() {
  return dispatch => {
    dispatch(fetchApiComponentInfo())
    return Info.get()
               .then(response => response.data)
               .then(json => dispatch(fetchApiComponentInfoSuccess(json)))
               .catch(function(error) {
                 dispatch(fetchApiComponentInfoFailure(error))
               })
  }
}
